import { render, staticRenderFns } from "./PluginInfo.vue?vue&type=template&id=a3afce44&"
import script from "./PluginInfo.vue?vue&type=script&lang=js&"
export * from "./PluginInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports